// src/components/Navigation.jsx

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const navItems = [
        {
            path: '/request/individual',
            label: 'T178 Permission Request',
            icon: '🔐',
            description: 'Request Tenant 178 permissions'
        },
        {
            path: '/my-requests',
            label: 'My Requests',
            icon: '📊',
            description: 'Track your access requests'
        }
    ];

    return (
        <nav className="main-nav">
            <div className="nav-brand" onClick={() => { window.location.href = '/'; }} style={{ cursor: 'pointer' }}>
                <span className="nav-logo">⚡</span>
                <div className="nav-brand-text">
                    <span className="nav-title">Permissions and Access Management Portal</span>
                    <span className="nav-subtitle">Request Access to Paragon Tenants</span>
                </div>

                <button
                    className="nav-hamburger"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    {mobileMenuOpen ? '✕' : '☰'}
                </button>
            </div>

            <div className={`nav-links ${mobileMenuOpen ? 'nav-links-open' : ''}`}>
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) =>
                            `nav-link ${isActive ? 'nav-link-active' : ''}`
                        }
                        onClick={() => {
                            setMobileMenuOpen(false);
                            // Force full reload for T178 to reset form state
                            if (item.path === '/request/individual' && window.location.pathname === '/request/individual') {
                                window.location.reload();
                            }
                        }}
                        end={item.path === '/request/individual'}
                    >
                        <span className="nav-link-icon">{item.icon}</span>
                        <span className="nav-link-label">{item.label}</span>
                    </NavLink>
                ))}
            </div>
        </nav>
    );
};

export default Navigation;